import { useState, useEffect, useContext } from 'react';
import { useForm } from '../../hooks';

import {
  Typography,
  Button,
  Grid,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

import StyledModal from './StyledModal';
import { TextField, CustomInput } from '../common';
import colors from '../../assets/colors';
import { employees } from '../../utils/api';
import FarmContext from '../../store/farm-context';

export default function AddEmployeeModal(props) {
  const [types, setTypes] = useState();
  const farmCTX = useContext(FarmContext);

  const handleClose = () => props.setOpen(false);
  const handleAddEmployee = () => {
    addEmployee();
    handleClose();
  };

  const { handleChange, values } = useForm({
    age: 0,
    email: '',
    employmentType: '',
    hourlyRate: 0,
    name: '',
    pesel: '',
    phoneNumber: '',
    skills: '',
    surname: '',
  });

  const addEmployee = () => {
    const body = {
      age: values.age,
      email: values.email,
      employmentType: values.employmentType,
      hourlyRate: values.hourlyRate,
      name: values.name,
      pesel: values.pesel,
      phoneNumber: values.phoneNumber,
      skills: values.skills,
      surname: values.surname,
    };
    employees.add(farmCTX.farmID, body).then(() => props.updateEmployees());
  };

  useEffect(() => {
    employees.types().then((result) => {
      setTypes(result.data);
    });
  }, [props.open]);

  return (
    <StyledModal open={props.open}>
      <IconButton
        onClick={handleClose}
        sx={{
          color: colors.redButton,
          position: 'absolute',
          top: 5,
          right: 5,
        }}
      >
        <CancelIcon />
      </IconButton>
      <Grid container justifyContent="center">
        <Typography sx={{ fontSize: 36, fontWeight: 500, mb: 4, mt: 1 }}>
          Dodaj pracownika
        </Typography>
      </Grid>

      <Grid container direction={'column'}>
        <Grid container justifyContent="left">
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: 'flex', justifyContent: 'flex-start' }}
          >
            <TextField modal label="Imię" onChange={handleChange('name')} />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: 'flex', justifyContent: 'flex-start' }}
          >
            <TextField
              modal
              label="Nazwisko"
              onChange={handleChange('surname')}
            />
          </Grid>
        </Grid>
        <Grid container justifyContent="left">
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: 'flex', justifyContent: 'flex-start' }}
          >
            <TextField
              modal
              label="PESEL"
              type="number"
              onChange={handleChange('pesel')}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: 'flex', justifyContent: 'flex-start' }}
          >
            <TextField
              modal
              label="Wiek"
              type="number"
              onChange={handleChange('age')}
            />
          </Grid>
        </Grid>
        <Grid container justifyContent="left">
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: 'flex', justifyContent: 'flex-start' }}
          >
            <TextField
              modal
              label="Numer telefonu"
              onChange={handleChange('phoneNumber')}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: 'flex', justifyContent: 'flex-start' }}
          >
            <TextField
              modal
              label="Adres mailowy"
              onChange={handleChange('email')}
            />
          </Grid>
        </Grid>
        <Grid container justifyContent="left">
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: 'flex', justifyContent: 'flex-start' }}
          >
            <FormControl fullWidth>
              <InputLabel>Forma zatrudnienia</InputLabel>
              <Select
                aria-label="select button"
                label="Forma zatrudnienia"
                input={<CustomInput />}
                defaultValue=""
                sx={{
                  textAlign: 'left',
                  borderRadius: '4px',
                  maxWidth: 275,
                }}
                onChange={handleChange('employmentType')}
              >
                {types?.map((type, index) => (
                  <MenuItem value={type} key={index}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: 'flex', justifyContent: 'flex-start', mt: 1 }}
          >
            <TextField
              modal
              label="Stawka godzinowa"
              type="number"
              onChange={handleChange('hourlyRate')}
            />
          </Grid>
        </Grid>
        <Grid container>
          <TextField
            modal
            label="Kwalifikacje i umiejętności"
            fullWidth
            onChange={handleChange('skills')}
          />
        </Grid>
        <Grid
          container
          justifyContent="right"
          alignContent="right"
          alignItems="right"
        >
          <Button
            type="submit"
            variant="outlined"
            onClick={handleAddEmployee}
            sx={{ mt: 2 }}
          >
            Dodaj
          </Button>
        </Grid>
      </Grid>
    </StyledModal>
  );
}
